import React from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import classNames from 'classnames/bind';
import { visNavDataModel } from './dataModel';
import styles from './visual-navigation.scss';
import { VisualNavigationCard } from './VisualNavigationCard';

const VisualNavigation = ({
  componentId,
  componentClass,
  componentPosition
}) => {
  const { data, loading, error } = useDataModel('component', {
    variables: {
      id: componentId,
      componentClass: 'VisualNavigation'
    }
  });

  if (!data || loading || error) {
    return null;
  }
  const cx = classNames.bind(styles);
  const visNavList = data?.component?.visualNavigationList;
  const cardCount = visNavList?.length;

  const getMobileVariantByCardCount = (count) => {
    if (count > 5) return '6';

    return '12';
  };

  const getDesktopVariantByCardCount = (count) => {
    if (count <= 4) return '3';

    return '2';
  };

  const mobileVariant = getMobileVariantByCardCount(cardCount);
  const tabletVariant = '3';
  const desktopVariant = getDesktopVariantByCardCount(cardCount);

  return (
    <div
      className={cx('card-tile__collection',
        'sui-grid',
        'sui-gap-1',
        `mobile-grid-cols-${mobileVariant}`,
        `tablet-grid-cols-${tabletVariant}`,
        `desktop-grid-cols-${desktopVariant}`
      )}
      id={`${componentClass}-${componentPosition}-${componentId}`}
      data-testid="visual-navigation"
      data-component-id={componentId}
      data-component-name={componentClass}
      data-component-position={componentPosition}
      data-component="VisualNavigation"
    >
      {visNavList.map((item, idx) => (
        <VisualNavigationCard
          item={item}
          key={idx + 1}
          position={idx + 1}
        />
      ))}
    </div>
  );
};

VisualNavigation.displayName = 'VisualNavigation';
VisualNavigation.propTypes = {
  componentId: PropTypes.string.isRequired,
  componentClass: PropTypes.string,
  componentPosition: PropTypes.number,
};

VisualNavigation.defaultProps = {
  componentClass: '',
  componentPosition: 1,
};

VisualNavigation.dataModel = visNavDataModel;

export { VisualNavigation };